import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class AuthService {
  login = ({ email, username, password }) => {
    return fetch(config.config.endpointUrls.login(), {
      method: 'POST',
      body: { email, username, password }
    })
  }
  logout = () => {
    return fetch(config.config.endpointUrls.logout(), {
      method: 'POST'
    })
  }
  resetPassword = ({ email, username }) => {
    return fetch(config.config.endpointUrls.resetPassword(), {
      method: 'POST',
      body: { email, username }
    })
  } 
  changePassword = ({ resetToken, password }) => {
    return fetch(config.config.endpointUrls.changePassword(), {
      method: 'POST',
      body: { resetToken, password }
    })
  } 

  changePasswordByUserId = ({ id = '@me', password }) => {
    return fetch(config.config.endpointUrls.changeUserPassword({ id }), {
      method: 'PUT',
      body: { password }
    })
  }

  fetchImageUploadUrl = params => {
    return fetch(config.config.endpointUrls.fetchImageUploadUrl(params), {
      method: 'GET'
    })
  }

  fetchPaypalCredentials = params => {
    return fetch(config.config.endpointUrls.fetchPaypalCredentials(params), {
      method: 'GET'
    })
  }

  setAuthContext = params => {
    return fetch(config.config.endpointUrls.setAuthContext(params), {
      method: 'POST',
      body: params
    })
  }

  changeInvalidPassword = params => {
    return fetch(config.config.endpointUrls.changeInvalidPassword(), {
      method: 'PUT',
      body: params
    })
  }

  getAuthContext = params => {
    return fetch(config.config.endpointUrls.getAuthContext(), {
      method: 'GET'
    })
  }
}

export default new AuthService()



// WEBPACK FOOTER //
// ../src/services/authService/authService.js